import React from 'react';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';
import { withAuthorization } from '../Session';
import Grid from '@material-ui/core/Grid';
import { compose } from 'recompose';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faTruckContainer } from '@fortawesome/pro-solid-svg-icons';
import * as ROUTES from '../../constants/routes';
import * as ROLES from '../../constants/roles';

const styles = (theme) => {
  const bigButtonSize = 150;
  return {
    bigButton: {
      width: bigButtonSize,
      height: bigButtonSize,
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50],
      color: theme.palette.primary.main,
      '&.activeButton': {
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.primary.light,
      },
    },
  };
};

function BigButton(props) {
  return (
    <Grid item xs={6}>
      <Grid container justifyContent={props.index % 2 === 0 ? 'flex-end' : 'flex-start'}>
        <Button
          variant="contained"
          onClick={props.onClick}
          className={`${props.className} ${props.active ? 'activeButton' : 'inactive'}`}
        >
          <div>
            <div>{props.button.icon}</div>
            <div>{props.button.name}</div>
          </div>
        </Button>
      </Grid>
    </Grid>
  );
}

class AdminNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.bigButtons = [
      {
        name: 'Users',
        icon: <FontAwesomeIcon icon={faUsers} size="2x" />,
        route: ROUTES.USERS,
      },
      {
        name: 'Freight Forwarders',
        icon: <FontAwesomeIcon icon={faTruckContainer} size="2x" />,
        route: ROUTES.FREIGHT_FORWARDERS_ADMIN,
      },
    ];
  }

  handleClick(button) {
    if (button.route) {
      this.props.history.push(button.route);
    }
  }

  render() {
    const { classes, location } = this.props;
    return (
      <Grid container spacing={2}>
        {this.bigButtons.map((bigButton, index) => {
          let active = location.pathname.startsWith(bigButton.route);
          return (
            <BigButton
              index={index}
              key={index}
              button={bigButton}
              active={active}
              className={classes.bigButton}
              onClick={() => this.handleClick(bigButton)}
            />
          );
        })}
      </Grid>
    );
  }
}

const condition = (authUser) => authUser && authUser.roles && authUser.roles.includes(ROLES.ADMIN);

export default compose(withAuthorization(condition), withStyles(styles))(AdminNavigation);
